import { ref } from 'vue'

type LogItem = {
  level: 'error' | 'warning' | 'info'
  message: string
  timestamp: Date
}

const logs = ref<LogItem[]>([])

export function useLog() {
  const addLog = (level: LogItem['level'], message: string) => {
    logs.value.push({
      level,
      message,
      timestamp: new Date(),
    })
  }

  const addError = (message: string) => {
    addLog('error', message)
  }

  const addWarning = (message: string) => {
    addLog('warning', message)
  }

  const addInfo = (message: string) => {
    addLog('info', message)
  }

  const clearLogs = () => {
    logs.value = []
  }

  return {
    logs,
    addLog,
    addError,
    addWarning,
    addInfo,
    clearLogs,
  }
}
